/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'nav-link',
  templateUrl: './nav-link.component.html',
  styleUrls: ['./nav-link.component.scss'],
  standalone: false
})
export class NavLinkComponent implements OnInit {
  @Input() route!: string;
  @Input() text!: string;

  constructor(private router: Router) {}

  ngOnInit(): void {}

  navigateTo() {
    this.router.navigateByUrl(this.route);
  }
}
